import React from 'react';
import { toast } from 'react-toastify';
import Message from 'Components/Admin/ToastMessage';

const defaultOptions = {
  type: toast.TYPE.SUCCESS,
  containerId: 'admin',
};

const adminMessage = (content, { type = toast.TYPE.SUCCESS, ...options } = {}) => {
  return toast(<Message {...content} type={type} />, {
    ...defaultOptions,
    ...options,
  });
};

export default adminMessage;
